{
    "home.title": "Mes Magasins",
    "home.store.openTasks": "Tâches Ouvertes",
    "home.stores.title": "Accueil",
    "home.noMobileAccess.title": "Ce compte n'a pas accès à l'application Badger Mobile.",
    "home.noMobileAccess.body": "Contactez votre responsable pour demander l'accès.",
    "home.noHomeStore.message": "Vous n'avez pas défini de magasin principal. Veuillez contacter votre responsable.",
    "home.myStores.title": "Mes Magasins",
    "home.myStores.link": "Magasins",
    "home.label.edit": "Mes Magasins",

    "tasks.label": "Tâches",
    "tasks.store.allTasks": "Toutes les Tâches",
    "tasks.filters.allTaskTypes": "Tous les Types de Tâches",
    "tasks.filters.allResolutionTypes": "Tous les Types de Résolution",
    "tasks.store.idLabel": "ID du Magasin",
    "tasks.store.outOfStock": "Rupture de Stock",
    "tasks.store.wrong": "Incorrect",
    "tasks.store.price": "Prix",
    "tasks.store.salePrice": "Prix Promo",
    "tasks.store.taskMap": "Carte des Tâches",
    "tasks.allAisles": "Tous les Rayons",
    "tasks.supress.message": "Cette tâche sera reportée pendant 7 jours.",
    "tasks.list.completeTask": "Terminer la Tâche",
    "tasks.list.flagTask": "Marquer la Tâche",
    "tasks.store": "Magasin",
    "tasks.aisles": "Allées",
    "tasks.complete.message": "Tâche complétée avec succès.",
    "tasks.error.message": "Une erreur s'est produite lors de l'exécution de la tâche.",
    "tasks.general.message": "Impossible de compléter la tâche.",

    "profile.title": "Profil",
    "profile.name.label": "Nom",
    "profile.email.label": "Email",
    "profile.organization.label": "Organisation",
    "profile.homeStore.label": "Magasin Principal",
    "profile.role.label": "Rôle",
    "profile.roles.label": "Rôles",

    "general.label.today": "Aujourd'hui",
    "general.label.search": "Rechercher",
    "general.label.comment": "Commentaire",
    "general.label.comments": "Commentaires",
    "general.label.resolved": "Résolu",
    "general.label.new": "Nouveau",
    "general.label.edit": "Modifier",
    "general.label.signOut": "Déconnexion",
    "general.label.actionable": "Actionnable",
    "general.action.save": "Enregistrer",
    "general.action.cancel": "Annuler",
    "general.action.close": "Fermer",
    "general.action.snooze": "Reporter",
    "general.action.create": "Créer",
    "general.home.title": "Accueil",
    "general.tasks.title": "Tâches",
    "general.users.title": "Profil",
    "general.rfid.title": "RFID",
    "general.label.products": "Produits",
    "general.action.prev": "Préc.",
    "general.action.next": "Suivant",
    "general.label.gtin": "GTIN",
    "general.label.all": "Tous",

    "sort.label.taskCount": "Nombre de Tâches",
    "sort.label.aisleName": "Nom du Rayon",
    "sort.label.aisleLocation": "Emplacement du Rayon",
    "sort.label.shelfLocation": "Emplacement de l'Étagère",
    "sort.label.taskType": "Type de Tâche",
    "sort.label.productName": "Nom du Produit",
    "sort.label.sku": "SKU",
    "sort.label.recurrenceCount": "Nombre de Récurrences",
    "sort.label.tagCount": "Nombre d’étiquettes",

    "task.type.price": "Prix",
    "task.type.salePrice": "Prix Promo",
    "task.type.outOfStock": "Rupture de Stock",
    "task.type.wrong": "Article Incorrect",

    "task.resolution.autoResolved": "Résolu Auto.",
    "task.resolution.completed": "Terminé",
    "task.resolution.flagged": "Marqué",
    "task.resolution.not a problem": "Pas un Problème",
    "task.resolution.no stock found": "Aucun Stock à Réapprovisionner",

    "task.status.active": "Actif",
    "task.status.completed": "Résolu",
    "task.status.suppressed": "Reporté",
    "task.status.expired": "Expiré",

    "tasks.paths.label": "Rayons",

    "validation.error.required": "Ce champ est requis",
    "validation.error.minLength": "La longueur minimale est de {{length}} caractères",

    "user.label.email": "Courriel",
    "user.label.email.placeholder": "Courriel",
    "user.label.email.error": "Courriel requis",
    "user.label.email.invalid": "Format de courriel invalide",
    "user.label.firstName": "Prénom",
    "user.label.firstName.placeholder": "Prénom",
    "user.label.firstName.error": "Prénom requis",
    "user.label.lastName": "Nom",
    "user.label.lastName.placeholder": "Nom",
    "user.label.lastName.error": "Nom requis",
    "user.label.organization": "Organisation",
    "user.label.homeStore": "Magasin principal",
    "user.label.homeStore.placeholder": "Rechercher des magasins principaux",
    "user.label.homeStore.noFound": "Aucun magasin principal trouvé",
    "user.label.allowedStores": "Magasins autorisés",
    "user.select.store.placeholder": "Rechercher des magasins",
    "user.select.store.noFound": "Aucun magasin trouvé",
    "user.label.roles": "Rôles",

    "rfid.label.tag": "Étiquette RFID",
    "rfid.label.allZones": "Toutes les zones",
    "rfid.label.serial": "Numéro de série",
    "rfid.label.epc": "EPC",
    "rfid.label.zone": "Zone",
    "rfid.label.date": "Date",
    "rfid.label.nonLocalized": "Non localisé",

    "signOut.success": "Votre session est terminée. Veuillez vous connecter pour accéder à votre compte.",
    "signOut.error": "Une erreur s'est produite lors de la déconnexion. Veuillez réessayer."
}
